import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import TopNav from "../../common/TopNav";
import SideBar from "../../common/SideBar";
import './ResetPassword.css';
import "../../common/topnav.css";
import { apiUrl } from '../../../config/config';

class ResetPassword extends Component {
  constructor() {
    super();
      const menus = [
        { title: "Verifier Home", url: "/verifier-home" },
        { title: "Patient list", url: "/patient-list" },
        { title: "Labled Patients", url: "/labled-patients" },
        { title: "Verified", url: "/verification-completed" },
        { title: "Verifier Dashboard", url: "/verifier-dashboard" },
  
      ];
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
      }
      if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(3, 0, { title: "Device Deatils", url: "/device-details" });
      }
  
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
      }
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
      }
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(6, 0, { title: "Support Web", url: "/support-homeweb" });
      }
      if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
      }
      if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, {
          title: "Supported Person",
          url: "/supported-persons",
        });
       
        }
         if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(6, 0, {
            title: "Reset Password",
            url: "/ResetPassword",
          });
      }
    this.state = {
      menus,
      userType: 'user',
      emailOrPhone: '',
      inputType: '',
      password: '',
      message: '',
      loading: false
    };
  }

  resetForm = () => {
    this.setState({
      emailOrPhone: '',
      password: '',
      verificationCode: '',
      message: '',
      step: 'request'
    });
  };

  requestResetCode = async () => {
    if (!this.state.emailOrPhone) {
      this.setState({ message: 'Please enter an email address or phone number.' });
      return;
    }

    this.setState({ loading: true });
    try {
      const endpoint = this.state.userType === 'user' 
        ? `${apiUrl}/api/users/requestResetCode` 
        : `${apiUrl}/api/users/requestResetCodepatient`;

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email: this.state.emailOrPhone // API still expects 'email' parameter
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to send reset code');
      
      this.setState({ 
        step: 'verify',
        message: 'Verification code has been sent to your email/phone.'
      });
    } catch (err) {
      this.setState({ message: err.message });
    } finally {
      this.setState({ loading: false });
    }
  };

  verifyResetCode = async () => {
    if (!this.state.verificationCode) {
      this.setState({ message: 'Please enter the verification code.' });
      return;
    }

    this.setState({ loading: true });
    try {
      const endpoint = this.state.userType === 'user' 
        ? `${apiUrl}/api/users/verifyResetCode` 
        : `${apiUrl}/api/users/verifyResetCodePatient`;

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email: this.state.emailOrPhone,
          code: this.state.verificationCode
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Invalid verification code');
      
      this.setState({ 
        step: 'reset',
        message: 'Code verified successfully. Please enter your new password.'
      });
    } catch (err) {
      this.setState({ message: err.message });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ message: '' });
    
    const { emailOrPhone, password, inputType } = this.state;

    if (!emailOrPhone) {
      this.setState({ message: 'Please enter an email address or phone number.' });
      return;
    }

    if (!password || password.length < 8) {
      this.setState({ message: 'Password must be at least 8 characters.' });
      return;
    }

    // Validate based on detected input type
    if (!inputType) {
      this.setState({ message: 'Please enter a valid email address or phone number.' });
      return;
    }

    if (inputType === 'email' && !emailOrPhone.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      this.setState({ message: 'Please enter a valid email address.' });
      return;
    }

    if (inputType === 'phone' && !emailOrPhone.match(/^\d{10}$/)) {
      this.setState({ message: 'Please enter a valid 10-digit phone number.' });
      return;
    }
    
    this.setState({ loading: true });
    try {
      const endpoint = this.state.userType === 'user' 
        ? `${apiUrl}api/users/userresetPassword` 
        : `${apiUrl}api/users/userresetPasswordPatient`;

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email: this.state.emailOrPhone,  // Changed to 'email' to match backend expectation
          password: this.state.password 
        }),
      });

      const data = await res.json();
      
      // Check if the request was successful
      if (data.success === false) {
        throw new Error(data.message || 'Failed to update password');
      }
      
      this.setState({ 
        message: 'Password updated successfully',
        emailOrPhone: '',
        password: ''
      });
    } catch (err) {
      this.setState({ message: err.message || 'Failed to update password' });
    } finally {
      this.setState({ loading: false });
    }
  };

  onChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'emailOrPhone') {
      // Remove spaces and special characters except @ and .
      const cleanValue = value.replace(/[^\w@.-]/g, '');
      
      // Detect if input is email or phone
      const isEmail = cleanValue.includes('@');
      const isPhone = /^\d+$/.test(cleanValue);
      
      this.setState({
        emailOrPhone: cleanValue,
        inputType: isEmail ? 'email' : (isPhone ? 'phone' : '')
      });
    } else {
      this.setState({ [name]: value });
    }
  };

  onUserTypeChange = (type) => {
    this.setState({ userType: type, message: '' });
  };

  render() {
    const { userType, username, password, message, loading } = this.state;

    const { auth } = this.props;
    
    const isSuccess = /success|updated/i.test(message || "");
    const inputBase = {
      width: "100%", height: 42, padding: "0 14px",
      background: "#0f3538", border: "1px solid rgba(46,170,187,0.3)",
      borderRadius: 8, color: "#e2eef2", fontSize: 14, outline: "none",
      transition: "border-color 0.2s, box-shadow 0.2s",
    };
    const labelStyle = {
      color: "#89a8c0", fontSize: 11, fontWeight: 600,
      textTransform: "uppercase", letterSpacing: "0.5px",
      marginBottom: 6, display: "block",
    };

    return (
      <div className="wrapper theme-6-active pimary-color-green" style={{ maxWidth: "none", width: "100%", background: "#041415" }}>
        <SideBar menus={this.state.menus} profileLink="verifier-profile" />
        <div className="right-sidebar-backdrop"></div>

        <div
          className="page-wrapper"
          style={{
            marginTop: 6,
            // Layered dark gradient — team palette with subtle cyan glow behind the card
            background:
              "radial-gradient(circle at 50% 35%, rgba(46,170,187,0.10) 0%, rgba(0,0,0,0) 55%), " +
              "linear-gradient(180deg, #041415 0%, #072224 70%, #041415 100%)",
            minHeight: "100vh",
            width: "100%",
            maxWidth: "none",
            padding: 0,
            marginRight: 0,
          }}
        >
          <div className="container-fluid" style={{ padding: 0, margin: 0, width: "100%", maxWidth: "none" }}>

            {/* Centered card */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", padding: "60px 16px 40px", minHeight: "calc(100vh - 6px)" }}>
              <div style={{
                width: "100%", maxWidth: 480,
                borderRadius: 14, overflow: "hidden",
                background: "linear-gradient(160deg,#0e2a2e 0%,#0a1f22 100%)",
                boxShadow: "0 24px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(46,170,187,0.18)",
              }}>

                {/* Header */}
                <div style={{
                  background: "linear-gradient(90deg,#0c2e32 0%,#0f3538 100%)",
                  padding: "20px 24px",
                  borderBottom: "1px solid rgba(46,170,187,0.18)",
                  display: "flex", alignItems: "center", gap: 14,
                }}>
                  <div style={{
                    width: 44, height: 44, borderRadius: 12,
                    background: "linear-gradient(135deg,rgba(46,170,187,0.3),rgba(46,170,187,0.08))",
                    border: "1px solid rgba(46,170,187,0.4)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 22, flexShrink: 0,
                  }}>🔐</div>
                  <div>
                    <div style={{ color: "#e2eef2", fontWeight: 700, fontSize: 17 }}>Reset Password</div>
                    <div style={{ color: "#4a8a9a", fontSize: 12, marginTop: 2 }}>
                      Update password for a User or Patient account
                    </div>
                  </div>
                </div>

                {/* Body */}
                <form onSubmit={this.handleSubmit} style={{ padding: "22px 24px", background: "#0a1f22" }}>

                  {/* User-type pill toggle */}
                  <label style={labelStyle}>Account Type</label>
                  <div style={{ display: "flex", gap: 8, marginBottom: 18 }}>
                    {[
                      { v: "user",    label: "👤 User",    color: "#2eaabb", rgb: "46,170,187" },
                      { v: "patient", label: "🧑‍⚕️ Patient", color: "#27ae60", rgb: "39,174,96"  },
                    ].map((t) => {
                      const active = userType === t.v;
                      return (
                        <button
                          key={t.v}
                          type="button"
                          onClick={() => this.onUserTypeChange(t.v)}
                          style={{
                            flex: 1, padding: "10px 0", fontSize: 13, fontWeight: 700,
                            background: active ? `rgba(${t.rgb},0.18)` : "transparent",
                            border: `1px solid ${active ? t.color : "rgba(154,179,189,0.25)"}`,
                            color: active ? t.color : "#9ab3bd",
                            borderRadius: 8, cursor: "pointer",
                            transition: "all 0.15s",
                          }}
                        >{t.label}</button>
                      );
                    })}
                  </div>

                  {/* Email / Phone */}
                  <label style={labelStyle}>📧 Email or Phone</label>
                  <div style={{ position: "relative", marginBottom: 16 }}>
                    <input
                      type="text"
                      name="emailOrPhone"
                      value={this.state.emailOrPhone}
                      onChange={this.onChange}
                      placeholder={`Enter ${userType} email or phone number`}
                      autoComplete="off"
                      style={{
                        ...inputBase,
                        paddingRight: 50,
                        borderColor: this.state.emailOrPhone
                          ? (this.state.inputType ? "#27ae60" : "#e74c3c")
                          : "rgba(46,170,187,0.3)",
                      }}
                    />
                    {this.state.emailOrPhone && (
                      <div style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", fontSize: 16, pointerEvents: "none" }}>
                        {this.state.inputType === "email" && <span title="Email">✉️</span>}
                        {this.state.inputType === "phone" && <span title="Phone">📱</span>}
                        {!this.state.inputType && <span title="Invalid" style={{ color: "#e74c3c" }}>⚠️</span>}
                      </div>
                    )}
                  </div>

                  {/* Password */}
                  <label style={labelStyle}>🔑 New Password</label>
                  <input
                    type="password"
                    name="password"
                    value={password}
                    onChange={this.onChange}
                    placeholder="Minimum 8 characters"
                    minLength="8"
                    style={{ ...inputBase, marginBottom: 6 }}
                  />
                  <div style={{ fontSize: 11, color: "#5a8fa8", marginBottom: 18 }}>
                    Use at least 8 characters. A mix of letters, numbers and symbols is recommended.
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: "100%", height: 44, fontSize: 14, fontWeight: 700,
                      background: loading ? "#1a3a3e" : "linear-gradient(90deg,#1e8449,#27ae60)",
                      border: "none", borderRadius: 8,
                      color: "#fff", cursor: loading ? "not-allowed" : "pointer",
                      letterSpacing: "0.4px",
                      boxShadow: "0 4px 12px rgba(39,174,96,0.25)",
                      transition: "transform 0.1s",
                    }}
                  >
                    {loading ? "🔄 Updating…" : "🔐 Update Password"}
                  </button>

                  {/* Inline status message */}
                  {message && (
                    <div style={{
                      marginTop: 16, padding: "10px 14px",
                      borderRadius: 8,
                      background: isSuccess ? "rgba(39,174,96,0.12)" : "rgba(231,76,60,0.12)",
                      border: `1px solid ${isSuccess ? "rgba(39,174,96,0.4)" : "rgba(231,76,60,0.4)"}`,
                      color: isSuccess ? "#2ecc71" : "#ff6b6b",
                      fontSize: 12, fontWeight: 500,
                      display: "flex", alignItems: "center", gap: 8,
                    }}>
                      <span>{isSuccess ? "✅" : "⚠️"}</span>
                      <span>{message}</span>
                    </div>
                  )}

                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(ResetPassword);